import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconArrowDown = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M10.7499 4.00146C10.7499 3.58725 10.4141 3.25146 9.99988 3.25146C9.58566 3.25146 9.24988 3.58725 9.24988 4.00146L9.24988 14.1912L6.53033 11.4716C6.23744 11.1787 5.76256 11.1787 5.46967 11.4716C5.17678 11.7645 5.17678 12.2394 5.46967 12.5323L9.46967 16.5323C9.61032 16.6729 9.80109 16.752 10 16.752C10.1989 16.752 10.3901 16.6725 10.5308 16.5318L14.5303 12.5323C14.8232 12.2394 14.8232 11.7645 14.5303 11.4716C14.2374 11.1787 13.7626 11.1787 13.4697 11.4716L10.7499 14.1914L10.7499 4.00146Z",
        fill: "black"
    }));

export { IconArrowDown };
